import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {FreeGameUIAct} from '@gongxigames/framework/slotV2/ui/acts/FreeGameUIAct';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {AutoplayCheckAfterFeatureUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayCheckAfterFeatureUIAct';

export class FreeGameUIState extends UIState {
    public static readonly ID = 'FreeGameUIState';

    public setAct(): void {
        this.act = sequence([
            FreeGameUIAct,
            AutoplayCheckAfterFeatureUIAct,
        ]);
    }

    public canExecute(): boolean {
        return slotStore.feature_type.value?.type === 'freeSpins';
    }
}